export const AUTH_KEYS = [
	'sessionToken',
	'vendorId',
	'userName',
	'sessionStatus',
	'sessionExpiresAt',
	'expiresAt',
	'isLoggedIn',
	'sessionID',
	'businessName',
	'businessLocation',
	'visitedMd',
	'visitedSc',
	'visitedMp',
	'visitedSsc'
];

const readFromEitherStorage = (key) =>
	localStorage.getItem(key) || sessionStorage.getItem(key);

export const getVendorId = () =>
	sessionStorage.getItem('vendorId') || localStorage.getItem('vendorId') || '';

export const getUserName = () =>
	sessionStorage.getItem('userName') || localStorage.getItem('userName') || getVendorId();

export const getSessionToken = () =>
	sessionStorage.getItem('sessionToken') || localStorage.getItem('sessionToken') || '';

export const getAuthStorage = () =>
	sessionStorage.getItem('sessionToken') ? sessionStorage : localStorage;

const toJsIsoMillis = (iso) => {
	if (!iso || typeof iso !== 'string') return null;

	const [date, time] = iso.split('T');
	if (!time) return null;

	const [hms, fracAndZone] = time.split('.');
	if (!fracAndZone) return iso;

	const hadZ = fracAndZone.endsWith('Z');
	const frac = (hadZ ? fracAndZone.slice(0, -1) : fracAndZone).slice(0, 3).padEnd(3, '0');
	return `${date}T${hms}.${frac}${hadZ ? 'Z' : ''}`;
};

export const normalizeSessionExpiry = (rawIso) => {
	if (!rawIso || typeof rawIso !== 'string') return null;

	const msIso = toJsIsoMillis(rawIso);
	const hasTimezone = /[zZ]|[+-]\d{2}:?\d{2}$/.test(msIso);

	let parsed = Date.parse(msIso);
	if (!hasTimezone) {
		const parsedUtc = Date.parse(msIso.endsWith('Z') ? msIso : `${msIso}Z`);
		if (Number.isFinite(parsedUtc)) parsed = parsedUtc;
	}

	if (!Number.isFinite(parsed)) return null;
	return new Date(parsed).toISOString();
};

const getStoredExpiry = () =>
	readFromEitherStorage('sessionExpiresAt') || readFromEitherStorage('expiresAt');

const isStoredSessionExpired = () => {
	const rawExpiry = getStoredExpiry();
	if (!rawExpiry) return false;

	const normalizedExpiry = normalizeSessionExpiry(rawExpiry);
	if (!normalizedExpiry) return true;

	return Date.now() > Date.parse(normalizedExpiry);
};

const migrateLegacyExpiryKey = (store) => {
	const legacyExpiry = store.getItem('expiresAt');
	if (!legacyExpiry || store.getItem('sessionExpiresAt')) return;

	const normalizedExpiry = normalizeSessionExpiry(legacyExpiry);
	if (normalizedExpiry) {
		store.setItem('sessionExpiresAt', normalizedExpiry);
		store.removeItem('expiresAt');
	}
};

export const clearAuthSession = () => {
	AUTH_KEYS.forEach(key => {
		localStorage.removeItem(key);
		sessionStorage.removeItem(key);
	});
};

export const setAuthSession = ({
	                               vendorId,
	                               sessionToken,
	                               sessionStatus,
	                               userName,
	                               expiresAt,
	                               rememberMe
                               }) => {
	clearAuthSession();

	const store = rememberMe ? localStorage : sessionStorage;
	store.setItem('isLoggedIn', 'true');
	store.setItem('vendorId', vendorId || '');
	store.setItem('sessionToken', sessionToken || '');
	store.setItem('sessionStatus', sessionStatus || '');
	store.setItem('userName', userName || '');

	if (expiresAt) {
		const normalizedExpiry = normalizeSessionExpiry(expiresAt);
		store.setItem('sessionExpiresAt', normalizedExpiry || expiresAt);
	}
};

export const getAuthSession = () => {
	const token = readFromEitherStorage('sessionToken');

	if (!token) {
		return {isLoggedIn: false};
	}

	if (isStoredSessionExpired()) {
		return {isLoggedIn: false};
	}

	return {isLoggedIn: true, token};
};

export const performMigrationCleanup = () => {
	migrateLegacyExpiryKey(localStorage);
	migrateLegacyExpiryKey(sessionStorage);

	const hasLoginFlag = localStorage.getItem('isLoggedIn') === 'true' ||
		sessionStorage.getItem('isLoggedIn') === 'true';
	const hasSessionToken = Boolean(readFromEitherStorage('sessionToken'));
	const isStranded = hasLoginFlag && !hasSessionToken;
	const hasExpiredSession = hasSessionToken && isStoredSessionExpired();

	if (isStranded || hasExpiredSession) {
		clearAuthSession();
	}
};
